export default class NativeVideo {
  video;
  cover;
  playon;
  coverNodeHasHeight = true;

  constructor(video) {
    this.video = video;
    this.cover = this.video.classList.contains('cover') ? true: false;
    if (this.cover) {
      this.coverVideo();
    }
    this.bindListeners();
  }

  coverVideo() {
    let coverNode = this.video.parentNode;
    let coverNodeW = coverNode.clientWidth;
    if (coverNode.clientHeight === 0 || !this.coverNodeHasHeight) { 
      coverNode.style.height = (coverNodeW * 9 / 16) + 'px';
      this.coverNodeHasHeight = false;
    }
    let coverNodeH = coverNode.clientHeight;
    if(coverNodeH <= coverNodeW * 9 / 16) {
      // adapt landscape
      this.video.style.width = coverNodeW + 'px';
      this.video.style.height = (coverNodeW * 9 / 16) + 'px';
    }
    else {
      // adapt portrait
      this.video.style.height = coverNodeH + 'px';
      this.video.style.width = (coverNodeH *  16 / 9) + 'px';
    }
    this.video.classList.add('covered');
  }

  bindListeners() {
    window.addEventListener('resize', () => {
      if(this.cover) {
        this.coverVideo();
      }
    });
  }
}


// WEBPACK FOOTER //
// ./ui/assets/js/NativeVideo/NativeVideo.js